<template>
  <v-list>
    <v-list-item @click="itemClicked(itemStat)">
      <i class="pr-1 fa-regular fa-magnifying-glass fa-xl"></i>
      View
    </v-list-item>
    <v-list-item @click="openActionStatus(itemStat)" v-if="hasRoles(constants.UPDATE_REGISTRATION_ROLES)">
      <div v-if="itemStat.status === 'closed'" class="action-stat-cont">
        <i class="pr-1 fa-light fa-toggle-on fa-xl"></i>
        Change status to Open
      </div>
      <div v-if="itemStat.status === 'open'" class="action-stat-cont">
        <i class="pr-1 fa-light fa-toggle-off fa-xl"></i>
        Change status to Closed
      </div>
    </v-list-item>
    <v-list-item
      v-if="hasRoles(constants.UPDATE_REGISTRATION_ROLES) && itemStat.regtype === 'scep'"
      @click="openActionPassword(currentItem)"
    >
      <i class="pr-2 fa-light fa-key fa-xl"></i>
      Change Password
    </v-list-item>
  </v-list>
</template>
<script>
import {mapGetters} from "vuex";
import * as constants from "@/config/constants";

export default {
    props: ["itemStat"],
  data() {
    return {};
  },
  computed: {
    constants() {
      return constants
    },
    ...mapGetters(["getRoles"])
  },
  methods:{
    hasRoles(roles) {
      return roles.every((role) => this.getRoles.includes(role));
    },
    itemClicked(value){
        this.$emit("itemClicked", value)
    },
    openActionStatus(value){
        this.$emit("openActionStatus", value)
    },
    openActionPassword(value){
        this.$emit("openActionPassword", value)
    }
  }
};
</script>
<style></style>
